import { Injectable } from '@angular/core';
import * as LogRocket from 'logrocket'

import { UsersService } from '@innersight-os/shared/firebase-services';
import { environment } from '../../environments/environment';
import { truthy } from '@innersight-os/shared/util-rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogRocketService {
  constructor(
    usersService: UsersService,
  ) {
    if(environment.production) {
      usersService.me$.pipe(truthy()).subscribe(me => {
        LogRocket.identify(me.id, {
          email: me.email,
          displayName: me.displayName,
          admin: me.roles?.admin || false,
          manager: me.roles?.manager || false,
          segmenter: me.roles?.segmenter || false,
        })
      })
    }
  }
}
